import { OptimizelyDecideOption, ReactSDKClient } from '@optimizely/react-sdk';

import { isMobileUserAgent } from '../utils/mobile';

// The BBID consumer-migration sign-up experiment is decided server-side by
// JG.IdentityAndAccess.Sso (see BbidExperimentControllerBase.cs) using the
// shared Optimizely project. Because we never call decide() for it on this
// client, no DECISION notification fires here and the experiment slug never
// reaches Heap. Replaying the decision on the client with the same inputs
// (loggedOutGuid + deviceType) triggers the existing Optimizely -> Heap
// listener so the slug shows up as a user property in Heap, matching the
// pattern used by the darkslide and fintech teams.
//
// We pass DISABLE_DECISION_EVENT so this replay does NOT dispatch a second
// impression event to Optimizely: the SSO has already enrolled the user, and
// firing another impression here (with different attributes than the server
// used) would inflate enrolment counts and skew variation distribution. The
// DECISION notification still fires with the variation key, which is all we
// need for Heap tagging.
export const BBID_SIGNUP_FLAG_KEY = 'consumerghostbusters_bbid_migration_signup';

export function replayBbidSignUpDecision(
  optimizely: ReactSDKClient,
  loggedOutGuid: string
) {
  if (!loggedOutGuid) return;

  optimizely.decide(
    BBID_SIGNUP_FLAG_KEY,
    [OptimizelyDecideOption.DISABLE_DECISION_EVENT],
    loggedOutGuid,
    { deviceType: isMobileUserAgent() ? 'Mobile' : 'Desktop' }
  );
}
